import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ProjectionService } from 'src/app/model/api-services/projection.service';


export type TypeAheadPrjRecord = {
	auth: 'EPSG' | 'ESRI';
	crs: 'PROJCS' | 'GEOGCS';
	projection: string;
	sr: string;
	srid: string;
}

@Component({
	selector: 'app-projection-typeahead',
	templateUrl: './projection-typeahead.component.html',
	styleUrls: ['./projection-typeahead.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectionTypeaheadComponent implements AfterViewInit {
	@ViewChild('menu', { static: true }) menu: ElementRef<HTMLDivElement>;
	@ViewChild('typeAhead', { static: true }) typeAhead: ElementRef<HTMLInputElement>;
	@ViewChild('dropdown', { static: true }) dropdown: ElementRef<HTMLDivElement>;
	@Output()
	prjChange: EventEmitter<TypeAheadPrjRecord> = new EventEmitter<TypeAheadPrjRecord>();
	private searchTerms = '';

	public selectedOption: string = '';
	public projection: any;

	public options: Array<any> = [];
	constructor(private changes: ChangeDetectorRef, private projs: ProjectionService) { }


	ngAfterViewInit(): void {

	}
	InputClick(event: any) {

	}
	TypeAheadSearch(event: any) {
		if (event.target.value.length < 3) {
			return;
		}
		if(event.which ===27 ) {
			return;
		}
		this.projs.GetPojections({
			terms: event.target.value,
			auth: '*',
			crs: '*',
			sr: true

		}).then((reply) => {
			if (reply.response.status === 'ok') {
				this.options = reply.response.results;
				this.ShowOptions(this.options.length > 0);
			} else {
				this.options = [];
				this.ShowOptions(this.options.length > 0);
			}
		})
	}
	Select(prjItem: any) {
		this.projection = prjItem;
		this.selectedOption = prjItem.projection;
		this.prjChange.emit(this.projection);
		this.changes.detectChanges();
	}
	ShowOptions(show: boolean) {
		$(this.dropdown.nativeElement).toggleClass('show', false);
		$(this.typeAhead.nativeElement).attr('aria-expanded', 'false');
		$(this.menu.nativeElement).toggleClass('show', false);
		($(this.typeAhead.nativeElement) as any).dropdown('toggle');
		this.changes.detectChanges();
	}
}
